import type { ReactNode } from 'react';
import { useTerminalStore } from '../store/useTerminalStore';
import { useTranslation } from '../i18n/useTranslation';

export function Shell({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const wsStatus = useTerminalStore((s) => s.wsStatus);

  const statusColor = {
    CONNECTED: 'bg-success',
    RECONNECTING: 'bg-warning animate-pulse',
    DISCONNECTED: 'bg-muted',
  }[wsStatus] ?? 'bg-muted';

  const statusLabel = t(`shell.ws.${wsStatus.toLowerCase()}`);

  return (
    <div className="h-full w-full max-w-full flex flex-col bg-background text-foreground overflow-hidden">
      {children}
      <footer className="flex items-center justify-between h-6 px-4 border-t border-border shrink-0">
        <span className="text-[9px] font-mono text-muted-foreground">
          {t('shell.footer_context')}
        </span>
        <div
          className="flex items-center gap-1.5 text-[9px] font-mono text-muted-foreground"
          data-testid="websocket-status"
        >
          <span className={`w-1.5 h-1.5 rounded-full ${statusColor}`} />
          {statusLabel}
        </div>
      </footer>
    </div>
  );
}
